import { useState, useEffect } from "react";

import ApiClient from "../../../ApiClient";

const apiClient = ApiClient();

const usePostPayment = (merchantId, merchantTransactionTeference) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isFetchingDetails, setIsFetchingDetails] = useState(true);
    const [isFetchingMerchantLogo, setIsFetchingMerchantLogo] = useState(true);
    const [isFetchingPaymentLink, setIsFetchingPaymentLink] = useState(false);
    const [isFetchingPaymentId, setIsFetchingPaymentId] = useState(false);
    const [paymentId, setPaymentId] = useState(null);
    const [merchantLogo, setMerchantLogo] = useState(null);
    const [details, setDetails] = useState(null);


    const {
        getMerchantLogo,
        getPaymentLink,
        getPaymentLinkDetailsFromTransaction,
        getPaymentServiceTransactionId } = apiClient;

    useEffect(() => {
        if (!merchantId) {
            setIsFetchingMerchantLogo(false);
            return;
        }

        const onSuccess = (response) => {
            if (response.succeeded === true) {
                setMerchantLogo(response.response.merchant_logo);
            } else {
                onFail();
            }
        }

        const onFail = () => {
            setIsFetchingMerchantLogo(false)
        }

        const fetchLogo = async () => {
            try {
                setIsFetchingMerchantLogo(true);
                await getMerchantLogo(merchantId, onSuccess, onFail);
            } catch (err) {
            } finally {
                setIsFetchingMerchantLogo(false);
            }
        }

        fetchLogo();
    }, [merchantId, getMerchantLogo]);

    useEffect(() => {
        if (!merchantTransactionTeference) {
            setIsFetchingDetails(false);
            return;
        }

        const onSuccess = (response) => {
            if (response.succeeded === true) {
                setDetails(response.response);
            }
        }
        const onFail = () => {}
        
        const getDetails = async () => {
            try {
                setIsFetchingDetails(true);
                await getPaymentLinkDetailsFromTransaction(merchantTransactionTeference, onSuccess, onFail);
            } catch (err) { 
            } finally {
                setIsFetchingDetails(false);
            }
        }

        getDetails();
    }, [merchantTransactionTeference, getPaymentLinkDetailsFromTransaction]);

    useEffect(() => {
        if (!merchantTransactionTeference) {
            return;
        }

        const onSuccess = (response) => {
            if (response.succeeded === true) {
                setPaymentId(response.response.payment_service_transaction_id);
            }
        }
        const onFail = () => {}
        
        const getDetails = async () => {
            try {
                setIsFetchingPaymentId(true);
                await getPaymentServiceTransactionId(merchantTransactionTeference, onSuccess, onFail);
            } catch (err) {
            } finally {
                setIsFetchingPaymentId(false);
            }
        }

        getDetails();
    }, [merchantTransactionTeference, getPaymentServiceTransactionId]);

    useEffect(() => {
        setIsLoading(
            isFetchingMerchantLogo || isFetchingDetails || isFetchingPaymentLink || isFetchingPaymentId);
    }, [isFetchingMerchantLogo, isFetchingDetails, isFetchingPaymentLink, isFetchingPaymentId]);

    const redirectToPaymentLink = (merchantId, referenceCode) => {
        var url = '';

        const onSuccess = (response) => {
            url = response.response.payment_link;
            window.location.replace(url);
        }

        const onFail = (response) => {
            console.log("failed to fetch url", response);
        }

        try {
            setIsFetchingPaymentLink(true);
            getPaymentLink({ "merchantId": merchantId, "referenceCode": referenceCode}, onSuccess, onFail);
        } catch (err) {
        } finally {
            setIsFetchingPaymentLink(false);
            return url;
        }
    }

    return {
        isLoading,
        merchantLogo,
        details,
        paymentId,
        redirectToPaymentLink,
    };
};

export default usePostPayment;
